import script from "./past-meetings-empty.vue?vue&type=script&setup=true&lang=ts"
export * from "./past-meetings-empty.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__